module.exports = __webpack_public_path__ + "img/ThoughtLeadershipContributor.f265ab7a.jpg";